/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} File_Upload_Api_Errors_File_Cannot_Be_EmptyInputs */

const nl_file_upload_api_errors_file_cannot_be_empty = /** @type {(inputs: File_Upload_Api_Errors_File_Cannot_Be_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Het bestand kan niet leeg zijn.`)
};

/**

* @param {File_Upload_Api_Errors_File_Cannot_Be_EmptyInputs} inputs
* @param {{ locale?: "nl" }} options
* @returns {LocalizedString}
*/
const file_upload_api_errors_file_cannot_be_empty = /** @type {((inputs?: File_Upload_Api_Errors_File_Cannot_Be_EmptyInputs, options?: { locale?: "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<File_Upload_Api_Errors_File_Cannot_Be_EmptyInputs, { locale?: "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return nl_file_upload_api_errors_file_cannot_be_empty(inputs)
});
export { file_upload_api_errors_file_cannot_be_empty as "file_upload.api_errors.file_cannot_be_empty" }